import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, Select, DatePicker, Modal, Form } from 'antd'
import TextArea from "antd/lib/input/TextArea"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import { DeleteButton } from "../../component/common/Buttons"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import { formItemLayout, tailLayout } from '../../js/globalParam'
import moment from 'moment'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    store_id: undefined | string,
    complaint_department_id: string | undefined,
    user_name: string | undefined,
    room_number: string | undefined,
    complaintDate: any,
    complaint_type_id: string | undefined,
    handle_status: number | undefined,
    handleDate: any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type department = {
    "department_id": string,
    "department_name": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        complaint_department_id: undefined,
        user_name: undefined,
        room_number: undefined,
        complaintDate: null,
        complaint_type_id: undefined,
        handle_status: undefined,
        handleDate: null
    }

    const [form] = Form.useForm()
    const [form2] = Form.useForm()
    const [editVisible, setEditVisible] = useState<boolean>(false)

    const [activeID, setActiveID] = useState<string | undefined>(undefined)
    const [activeRecord, setActiveRecord] = useState<{ id: string, no_yet_pay_amount?: number, user_name?: string } | undefined>()

    const [recordInVisible, setRecordInVisible] = useState<boolean>(false)
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [data, setData] = useState<any>([])
    const [bmData, setBmData] = useState<department[]>([])

    const [complaintTypeData, setComplaintTypeData] = useState<{ "complaint_type_id": string, "complaint_type_name": string }[]>([])
    const [handleNameData, setHandleNameData] = useState<any[]>([])
    const [recordInBmData, setRecordInBmData] = useState<department[]>([])

    const [loading, setLoading] = useState<boolean>(false)

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        baseAxiosNoInfo('/global/complaint_type_list', { params: {} }).then((res: any) => {
            res && setComplaintTypeData(res)
        })
    }, [])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')
            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'complaintDate', ['complaint_date_start', 'complaint_date_end'])
        handleDate(params, 'handleDate', ['handle_date_start', 'handle_date_end'])

        axiosTable.get('/keeper/customer_complaint/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const exportExcel = () => {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'complaintDate', ['complaint_date_start', 'complaint_date_end'])
        handleDate(params, 'handleDate', ['handle_date_start', 'handle_date_end'])

        baseAxiosComplete.get('/keeper/customer_complaint/export', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    const onFinish = (value: any) => {
        baseAxiosComplete.post('/keeper/customer_complaint/submit_handle', {
            complaint_id: activeRecord?.id,
            handle_time: value.handle_time.format('YYYY-MM-DD HH:mm:ss'),
            handle_department_list_id: value.handle_department_list_id,
            handle_man_id: value.handle_man_id,
            handle_man_name: value.handle_man_name,
            handle_content: value.handle_content

        }).then((res: any) => {
            if (res.status === 0) {
                fetch({ pagination, fetchOtherParams: fetchOtherParamsTmpl })
                setRecordInVisible(false)
            }
        })
    }

    const onFinish2 = (value: any) => {
        baseAxiosComplete.post('/keeper/customer_complaint/update', {
            complaint_id: activeID,
            complaint_time: value.complaint_time.format('YYYY-MM-DD HH:mm:ss'),
            complaint_type_id: value.complaint_type_id,
            complaint_department_id: value.complaint_department_id,
            complaint_content: value.complaint_content

        }).then((res: any) => {
            if (res.status === 0) {
                fetch({ pagination, fetchOtherParams: fetchOtherParamsTmpl })
                setEditVisible(false)
            }
        })
    }

    let bmOptions = bmData.map((el: any) => (<Option value={el.department_id} key={el.department_id}>{el.department_name}</Option>))

    return (<div className="common-page">
        {/* 管家中心 -> 入住管理 -> 客诉管理 */}
        <BreadCrumb position={['管家中心', '客诉管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores value={fetchOtherParams.store_id} onChange={(v: string) => {
                        handleChange(v, 'store_id')
                        // 查询责任部门
                        baseAxiosNoInfo('/global/first_level_dep_of_store', {
                            params: {
                                store_id: v
                            }

                        }).then((res: any) => {
                            res && setBmData(res)
                        })
                    }} />
                </div>
                <Select className="fl" mode="multiple" virtual={false} style={{ marginRight: 8, marginBottom: 12, width: 250 }} placeholder="责任部门（可多选，先选门店）" value={fetchOtherParams.complaint_department_id ? fetchOtherParams.complaint_department_id.split(',') : undefined} onChange={(v: any) => { handleChange(v.join(','), 'complaint_department_id') }}>
                    {bmOptions}
                </Select>

                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'user_name') }} value={fetchOtherParams.user_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="房间号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'room_number') }} value={fetchOtherParams.room_number} />

                <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: 150 }} placeholder="客诉类型" value={fetchOtherParams.complaint_type_id} onChange={(v: string) => { handleChange(v, 'complaint_type_id') }}>
                    {complaintTypeData.map(el => <Option value={el.complaint_type_id} key={el.complaint_type_id}>{el.complaint_type_name}</Option>)}
                </Select>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["客诉开始日期", "客诉结束日期"]} value={fetchOtherParams.complaintDate} onChange={(v: any) => { handleChange(v, 'complaintDate') }} />
                <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="客诉状态" value={fetchOtherParams.handle_status} onChange={(v: number) => { handleChange(v, 'handle_status') }}>
                    <Option value={0} key={0}>待处理</Option>
                    <Option value={1} key={1}>已处理</Option>
                </Select>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["处理开始日期", "处理结束日期"]} value={fetchOtherParams.handleDate} onChange={(v: any) => { handleChange(v, 'handleDate') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed" >导出</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="门店" dataIndex="store_name" key="store_name" />
                <Column title="客户姓名" dataIndex="user_name" key="user_name" />
                <Column title="房间号" dataIndex="room_number" key="room_number" />
                <Column title="客诉类型" dataIndex="complaint_type_name" key="complaint_type_name" />
                <Column title="客诉内容" dataIndex="complaint_content" key="complaint_content" width={520} render={
                    info => {
                        let br = <br></br>;
                        let result = null;
                        let content_list = info.split('\n')
                        for (let j = 0; j < content_list.length; j++) {
                            if (j === 0) {
                                result = content_list[j];
                            } else {
                                result = <span>{result}{br}{content_list[j]}</span>;
                            }
                        }
                        return <div>{result}</div>;
                    }} />
                <Column title="客诉时间" dataIndex="complaint_time" key="complaint_time" />
                <Column title="登记人" dataIndex="create_user_name" key="create_user_name" />

                <Column title="责任部门" dataIndex="complaint_department_name" key="complaint_department_name" />
                <Column title="处理状态" dataIndex="handle_status" key="handle_status" render={(v: any) => {
                    switch (v) {
                        case 0:
                            return '待处理'
                        case 1:
                            return '已处理'
                    }
                }} />
                <Column title="处理方案" dataIndex="handle_content" key="handle_content" width={520} render={
                    info => {
                        let br = <br></br>;
                        let result = null;
                        let content_list = info.split('\n')

                        for (let j = 0; j < content_list.length; j++) {
                            if (j === 0) {
                                result = content_list[j];
                            } else {
                                result = <span>{result}{br}{content_list[j]}</span>;
                            }
                        }
                        return <div>{result}</div>;
                    }} />
                <Column title="处理人" dataIndex="handle_man_name" key="handle_man_name" />
                <Column title="处理时间" dataIndex="handle_time" key="handle_time" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        return (<Space size="middle">
                            {permission.includes('编辑') && record.handle_status === 0 && <Button type="primary" size="small" onClick={() => {
                                baseAxiosNoInfo('keeper/customer_complaint/detail', { params: { complaint_id: record.complaint_id } }).then((res: any) => {
                                    if (res) {
                                        console.log(res.complaint_time)

                                        form2.setFieldsValue({
                                            complaint_time: moment(res.complaint_time),
                                            complaint_type_id: res.complaint_type_id,
                                            complaint_department_id: res.complaint_department_id,
                                            complaint_content: res.complaint_content
                                        })

                                        setActiveID(res.id)
                                        setEditVisible(true)

                                        // 查询该门店的部门
                                        baseAxiosNoInfo('/global/department_list_by_store', {
                                            params: {
                                                store_id: res.store_id
                                            }

                                        }).then((res2: any) => {
                                            baseAxiosNoInfo('/global/first_level_dep_of_store', {
                                                params: {
                                                    check_in_id: record.check_in_id
                                                }

                                            }).then((res: any) => {
                                                res && setRecordInBmData(res)
                                            })
                                        })
                                    }
                                })
                            }}>编辑</Button>}

                            {permission.includes('删除') && record.handle_status === 0 && <DeleteButton
                                url="/keeper/customer_complaint/delete" record={record} cb={handleSearch}
                            >删除</DeleteButton>}

                            {permission.includes('录入处理方案') && record.handle_status === 0 && <Button size="small" onClick={() => {
                                baseAxiosNoInfo('/global/first_level_dep_of_store', {
                                    params: {
                                        store_id: record.store_id
                                    }

                                }).then((res: any) => {
                                    res && setRecordInBmData(res)
                                })

                                form.setFieldsValue({
                                    handle_time: undefined,
                                    handle_department_list_id: undefined,
                                    handle_man_name: undefined,
                                    handle_content: undefined,
                                })

                                setRecordInVisible(true)
                                setActiveRecord({ id: record.complaint_id })
                            }} >录入处理方案</Button>}
                        </Space>)
                    }}
                />
            </Table>
        </div>

        {/* 编辑弹窗 */}
        <Modal title={"编辑客诉"} visible={editVisible} onCancel={() => { setEditVisible(false) }} footer={false} width="400px">
            <Form form={form2} name="validate_other" {...formItemLayout} onFinish={onFinish2} >
                <Form.Item label="客诉时间" name="complaint_time">
                    <DatePicker showTime style={{ width: 200 }} />
                </Form.Item>

                <Form.Item required label="客诉类型" name="complaint_type_id" >
                    <Select style={{ width: 200 }}>
                        {complaintTypeData.map(el => <Option value={el.complaint_type_id} key={el.complaint_type_id}>{el.complaint_type_name}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item label="客诉部门" name="complaint_department_id">
                    <Select style={{ width: 200 }} >
                        {recordInBmData.map((el: any) => <Option key={el.department_id} value={el.department_id}>{el.department_name}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item label="客诉内容" name="complaint_content" >
                    <TextArea style={{ height: 200 }} />
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>

        {/* 审核弹窗 */}
        <Modal title="录入处理方案" visible={recordInVisible} footer={false} onCancel={() => { setRecordInVisible(false) }}>
            <Form {...formItemLayout} form={form} onFinish={onFinish} >
                <Form.Item label="处理时间" name="handle_time" rules={[{ required: true, message: '必须选择处理时间' }]}>
                    <DatePicker showTime />
                </Form.Item>

                <Form.Item label="处理部门" name="handle_department_list_id" rules={[{ required: true, message: '必须选择处理部门' }]}>
                    <Select virtual={false} placeholder="处理部门" onChange={(value: string) => {
                        baseAxiosNoInfo('/global/employee_list_by_position', {
                            params: {
                                department_id: value
                            }

                        }).then((res: any) => {
                            res && setHandleNameData(res)
                        })
                    }}>
                        {recordInBmData.map((el: any) => <Option key={el.department_id} value={el.department_id}>{el.department_name}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item label="处理人" name="handle_man_name" rules={[{ required: true, message: '必须选择处理人' }]}>
                    <Select virtual={false} placeholder="处理人" >
                        {handleNameData.map((el: any) => <Option key={el.employee_id} value={el.employee_id}>{el.user_name}</Option>)}
                    </Select>
                </Form.Item>

                <Form.Item label="处理方案" name="handle_content" rules={[{ required: true, message: '必须填写处理方案' }]}>
                    <TextArea style={{ height: 150 }} />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}